import { render, staticRenderFns } from "./AgentTopbar.vue?vue&type=template&id=36faa17a&scoped=true&"
import script from "./AgentTopbar.vue?vue&type=script&lang=js&"
export * from "./AgentTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36faa17a",
  null
  
)

export default component.exports